import ReactDOM from "react-dom/client";
import App from "./App";
import { store } from "@store/index";
import { hydratePrefs } from "@store/persistence";
import { setMode } from "@store/slices/themeSlice";
import { setSelectedOrgId } from "@store/slices/viewSlice";
import { setWorkspaceId } from "@store/slices/workspaceSlice";
import { setOnboardingState } from "@features/onboarding/state/onboardingSlice";
import { Provider } from "react-redux";
import "./styles/index.css";

try {
  localStorage.removeItem("persist:root");
} catch {
  // private browsing / quota — silently noop
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

(async () => {
  const prefs = await hydratePrefs();
  if (prefs.themeMode !== undefined) {
    store.dispatch(setMode(prefs.themeMode));
  }
  if (prefs.selectedOrgId !== undefined) {
    store.dispatch(setSelectedOrgId(prefs.selectedOrgId));
  }
  if (prefs.workspaceId !== undefined) {
    store.dispatch(setWorkspaceId(prefs.workspaceId));
  }
  if (prefs.onboardingState !== undefined) {
    store.dispatch(setOnboardingState(prefs.onboardingState));
  }
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
})();
